<template>
  <div>
    <task-next-contact-at />

    <task-tags />

    <section-page
      title="Task Templates"
      description="Task templates allow you to create template that can be reused throughout Forefront."
    >
      <template v-slot:right>
        <button-outlined class="ml-50" icon-left="plus" @click="createTaskTemplate">
          New Template
        </button-outlined>
      </template>

        <table-paginated
          ref="taskTemplateTable"
          :column-scope="vm"
          :actions-width="120"
          :per-page="25"
          :default-sort="['label', 'asc']"
          :show-per-page-option="true"
          :load-data="getTaskTemplates"
          :columns="taskTemplateColumns"
          empty-heading="You don't have any templates. Why don't you make one."
        >
          <template v-slot:actions="items">
            <button-link @click="editTaskTemplate(items.row)">Manage</button-link>
          </template>
        </table-paginated>
    </section-page>

    <section-page
      title="Task Lists"
      description="Task lists allow you to group your task templates that can be reused throughout Forefront."
    >
      <template v-slot:right>
        <button-outlined icon-left="plus" @click="createTaskList">
          New List
        </button-outlined>
      </template>

      <app-loading-section
        :count="taskLists.length"
        :loading="taskListLoading"
        heading="You don't have any list. Why don't you make one."
      >
        <table-default
          :table-data="taskLists"
          default-sort="label"
        >
          <b-table-column label="Label" field="label" sortable v-slot="props">
            {{ props.row.label }}
          </b-table-column>

          <b-table-column label="# Templates" field="task_templates" centered sortable v-slot="props">
            {{ props.row.task_templates.length }}
          </b-table-column>

          <b-table-column label="Description" field="description" v-slot="props" width="400">
            {{ utils.truncateString(props.row.description, 70) }}
          </b-table-column>

          <b-table-column cell-class="action_cell" width="120" v-slot="props">
            <button-link @click="editTaskList(props.row)">Manage</button-link>
          </b-table-column>
        </table-default>
      </app-loading-section>
    </section-page>

    <modal-container>
      <modal-crud-form
        ref="taskTemplateModal"
        title="Task Template"
        @saved="reloadTaskTemplates"
        form-component="task-template-form">
      </modal-crud-form>

      <modal-crud-form
        ref="taskListModal"
        title="Task List"
        form-component="task-list-form"
        @saved="getTaskLists"
      />

      <modal-form-edit
        ref="editTaskListModal"
        title="Task List"
        form-component="task-list-form"
        @close="loadTasksData"
      >
        <task-list-templates :task-list-id="taskListId"/>
      </modal-form-edit>
    </modal-container>
  </div>
</template>

<script>
import api from "../../api";
import utils from "../../services/utils";
import {ENUMS} from "../../services/enums";
import TablePaginated from "../../components/table/TablePaginated.vue";
import TaskTags from "./components/TaskTags.vue";
import TaskListTemplates from "./components/TaskListTemplates.vue";
import TaskNextContactAt from "./components/TaskNextContactAt.vue";

export default {
  name: "TaskSettingTab",
  components: {
    TaskNextContactAt,
    TablePaginated,
    TaskListTemplates,
    TaskTags,
  },
  data() {
    return {
      taskListLoading: true,
      taskListId: null,
      taskLists: [],
      taskTemplateColumns: [
        {
          label: 'Task',
          sortable: true,
          field: 'label',
        },
        {
          label: 'User Role',
          display(taskTemplate) {
            const role = Object.values(ENUMS.UserRoleEnum).find(role => role.value === taskTemplate.user_role)
            return (role) ? role.label : '--'
          },
        },
        {
          label: 'Assigned To',
          display(taskTemplate, vm) {
            const user = vm.users.find(u => u.id === taskTemplate.assign_to_id)
            return (user) ? user.full_name : '--'
          },
        },
        {
          label: 'Description',
          width: 400,
          display(taskTemplate, vm) {
            return  vm.utils.truncateString(taskTemplate.description, 70)
          }
        },
      ]
    }
  },
  mounted() {
    this.getTaskLists()
  },
  computed: {
    users() {
      return this.$store.getters.activeUsers;
    },
    vm() {
      return this;
    },
    utils() {
      return utils
    },
  },
  methods: {
    loadTasksData() {
      this.reloadTaskTemplates().then(() => {
        this.getTaskLists()
      })
    },
    getTaskTemplates(query = '') {
      return api.taskTemplates.all(query)
    },
    reloadTaskTemplates() {
      return this.$refs.taskTemplateTable.reloadData();
    },
    createTaskTemplate() {
      this.$refs.taskTemplateModal.open();
    },
    editTaskTemplate(template) {
      this.$refs.taskTemplateModal.open(template);
    },
    getTaskLists() {
      this.taskListLoading = true
      return api.taskLists.all()
        .then(res => {
          this.taskLists = res.data
        })
        .finally(() => this.taskListLoading = false)
    },
    createTaskList() {
      this.$refs.taskListModal.open()
    },
    editTaskList(list) {
      this.$refs.editTaskListModal.open(list)
      this.taskListId = list.id
    },
  }
}
</script>

<style scoped>

</style>
